export default __webpack_public_path__ + "static/media/rewind.a341c43a.svg";